export default __webpack_public_path__ + "images/ng-b69ed1e58b69dcadbf0e30265064ee70.svg";